import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { WebsiteService } from 'src/app/core/services/website.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss',`./styles/newsletter.${env.template_id}.component.scss`],
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class NewsletterComponent {
  form: UntypedFormGroup = new UntypedFormGroup({
    contact_email: new UntypedFormControl(null, [Validators.email])
  });
  step: 1 | 2 = 1;

  loading: boolean = false;

  errorMessage: string = "";

  constructor(
    private _websiteService: WebsiteService
  ){}


  send(){

    if(this.form.valid && this.form.value.contact_email){

      this.step = 1;
      this.errorMessage = "";

      this._websiteService
        .setNewsletterRequest(this.form.value)
        .subscribe(
        (res:any)=>{

          if(res.status == 201){

            this.step = 2;
            this.form.reset();

          }else{

            this.errorMessage = res.error;

          }

        },
        (err)=>{
          console.error(err)
          this.errorMessage = 'Error inesperado...';
          this.loading = false;
        },
        ()=>{
          this.loading = false;
        }
      )

    }

  }
}
